/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { PaginatedResponse, SentReviewData, ReceivedReviewData } from "./types";

type ReviewState = {
  sentReviews: PaginatedResponse<SentReviewData>;
  receivedReviews: PaginatedResponse<ReceivedReviewData>;
  loading: boolean;
}

const initialState: ReviewState = {
  sentReviews: {
    data: [],
    total: 0,
    per_page: 0,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    previous_page_url: "",
  },
  receivedReviews: {
    data: [],
    total: 0,
    per_page: 0,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    previous_page_url: "",
  },
  loading: false, // Default loading state
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    setSentReviews: (state, action) => {
      state.sentReviews = { ...state.sentReviews, ...action.payload };
    },
    setReceivedReviews: (state, action) => {
      state.receivedReviews = { ...state.receivedReviews, ...action.payload };
    },
    resetReviews: (state) => {
      state.sentReviews = initialState.sentReviews;
      state.receivedReviews = initialState.receivedReviews;
    },

    setLoading: (state, action) => {
      state.loading = action.payload; // Update loading state
    },
  },
});

export const { setSentReviews, setReceivedReviews, resetReviews, setLoading } = reviewSlice.actions;

export default reviewSlice.reducer;